import React, { PropTypes, Component } from 'react';
import * as B from 'react-bootstrap';
import './fileInput.scss';

class FileInput extends Component {
  static imageFileExtensions = /(jpg|png|gif|bmp)/;
  static propTypes = {
    label: PropTypes.string.isRequired,
    multiple: PropTypes.bool,
    allowedFileExtensions: PropTypes.arrayOf(PropTypes.string),
    files: PropTypes.arrayOf(PropTypes.object),
    progress: PropTypes.arrayOf(PropTypes.any),
    onChange: PropTypes.func.isRequired,
  };
  filesSelected(ev) {
    this.props.onChange(this.input.files);
  }
  fileExtension(fileName) {
    let parts = fileName.split('.');
    return parts[parts.length - 1];
  }
  glyph(fileName) {
    let extension = this.fileExtension(fileName);
    if (FileInput.imageFileExtensions.test(extension)) {
      return "picture";
    }
    return "file";
  }
  render() {
    let { props } = this;
    return (
      <B.FormGroup className="file-input-container">
        <B.Button bsStyle="primary" disabled={!!props.progress} className="file-input-btn">{props.label}</B.Button>
        <B.FormControl type="file" disabled={!!props.progress} className="file-input" inputRef={c => this.input = c}
          multiple={props.multiple} onChange={this.filesSelected.bind(this)}
          accept={props.allowedFileExtensions
            ? props.allowedFileExtensions.map(s => '.' + s).join(',')
            : undefined
          }
        />
        <B.ListGroup className="file-input-filelist">
          {
            props.files.map((f, i) => {
              let progress = props.progress && props.progress[i];
              return (
                <B.ListGroupItem key={i}>
                  <B.Glyphicon className="file-input-file-icon" glyph={this.glyph(f.name)} />
                  <span>{f.name}</span>
                  {
                    progress ? (
                      <B.Grid fluid>
                        <B.Row className="show-grid" className="file-input-upload">
                          <B.Col sm={6} md={5} lg={3} className="file-input-upload-icon-wraper">
                            {
                              progress !== true ? (
                                <B.Glyphicon glyph="cloud-upload" className="file-input-upload-icon" />
                              ) : undefined
                            }
                            <span className="file-input-upload-label">
                              {progress === true ? 'Sent' : 'Uploading'}
                            </span>
                          </B.Col>
                          <B.Col sm={6} md={7} lg={9} className="file-input-upload-progress-wraper">
                            <B.ProgressBar className="file-input-upload-progress"
                              striped={progress !== true}
                              active={progress !== true}
                              now={progress === true || progress === false ? 100 : progress}
                              bsStyle={progress === true ? 'success' : undefined}
                            />
                          </B.Col>
                        </B.Row>
                      </B.Grid>
                    ) : undefined
                  }
                </B.ListGroupItem>
              );
            })
          }
        </B.ListGroup>
      </B.FormGroup>
    );
  }
}

export default FileInput;



// WEBPACK FOOTER //
// ./components/lib/FileInput/index.js